import React, {useState} from 'react';

import './styles.scss';
import * as fonts from '../../../util/fonts';
import {createClassName} from '../../../util/utility';
import {Row} from '../../layout';
import Icon from '../../icon';
import {Icons} from '../../../util/icons';
import colors from '../../../util/colors';
import AppErrorMessage from '../../app-error-message';

interface AppTextInputProps extends React.HTMLProps<HTMLInputElement> {
  onChange(value: any): any;
  placeholder?: any;
  className?: string;
  error?: string | boolean;
  autoComplete?: string;
  errorBubbleMessage?: string;
  customInputIcon?: any;
  errorIconClass?: string;
  maxLength?: number;
}

function AppTextInput({
  value,
  onChange,
  placeholder,
  className,
  error,
  autoComplete,
  errorBubbleMessage,
  customInputIcon,
  errorIconClass,
  maxLength,
  ...rest
}: AppTextInputProps) {
  const [hoverErrorIcon, setHoverErrorIcon] = useState(false);
  const classes = createClassName('app-text-input', className);

  return (
    <Row
      className={
        className?.includes('forgot-password-email-input') ||
        className?.includes('forgot-email-nif-input')
          ? `app-text-input-row ${className}`
          : 'app-text-input-row'
      }>
      <input
        autoComplete={autoComplete}
        className={classes}
        style={{...fonts.M}}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder={placeholder}
        maxLength={maxLength ? maxLength : -1}
        {...rest}
      />

      {error && (
        <Icon
          style={{backgroundColor: 'white'}}
          onMouseOver={() => {
            setHoverErrorIcon(true);
          }}
          onMouseOut={() => {
            setHoverErrorIcon(false);
          }}
          changeViewbox
          viewBox={'0 0 24 24'}
          width="24"
          height="24"
          className={errorIconClass ? errorIconClass : 'app-form-field-error'}
          name={Icons.ALERT_PROBLEM}
          color={colors.alertRed}
        />
      )}

      {customInputIcon && customInputIcon}

      {hoverErrorIcon && errorBubbleMessage && (
        <AppErrorMessage
          message={errorBubbleMessage}
          className={
            errorBubbleMessage
              ? 'profile-pop-up-error-messages-name-match'
              : 'profile-pop-up-error-messages'
          }
        />
      )}
    </Row>
  );
}

export default AppTextInput;
